import loadable from "@loadable/component";

export const Login = loadable(() => import("./login/Login"));
export const Logout = loadable(() => import("./login/Logout"));
export const Main = loadable(() => import("./main/Main"));
export const StudyToday = loadable(() => import("./today/StudyToday"));
export const AllNewStudyToday = loadable(() => import("./today/AllNewStudyToday"));
export const AllNewCardGallery = loadable(() => import("./today/AllNewCardGallery"));
export const StudySmart = loadable(() => import("./smart/StudySmart"));
export const StudyTop = loadable(() => import("./top/StudyTop"));
export const ClassDetail = loadable(() => import("./class/ClassDetail"));
export const ExpDetail = loadable(() => import("./class/ExpDetail.js"));
export const SearchMain = loadable(() => import("./search/SearchMain"));
export const Mypage = loadable(() => import("./mypage/Mypage"));
export const MyInfo = loadable(() => import("./mypage/MyInfo"));
export const MyAatb = loadable(() => import("./mypage/MyAatb"));
export const MyNoti = loadable(() => import("./mypage/MyNoti"));
export const MyNote = loadable(() => import("./mypage/MyNote"));
export const MyCalendarChg = loadable(() => import("./mypage/MyCalendarChg"));
export const MyExamInfo = loadable(() => import("./mypage/MyExamInfo"));
export const MyExamScore = loadable(() => import("./mypage/MyExamScore"));
export const MyQnaMain = loadable(() => import("./mypage/myClass/MyQnaMain"));
export const MyQnaDetail = loadable(() => import("./mypage/myClass/MyQnaDetail"));
export const MyQnaWrite = loadable(() => import("./mypage/myClass/MyQnaWrite"));
export const MyStudyPlan = loadable(() => import("./mystudy/MyStudyPlan"));
export const MyStudyState = loadable(() => import("./mystudy/MyStudyState"));
export const MyStudyAllTab = loadable(() => import("./mystudy/MyStudyAllTab"));
export const AllTabFileUpload = loadable(() => import("components/allTab/AllTabFileUpload"));
export const MyAllTabSchedule = loadable(() => import("./mystudy/MyAllTabSchedule"));
export const MyStudyClas = loadable(() => import("./mystudy/MyStudyClas"));
export const ClasRegTimeTable = loadable(() => import("components/mystudy/studyPlan/clasReg/ClasRegTimeTable"));
export const ClasUpdTimeTable = loadable(() => import("components/mystudy/studyPlan/clasUpd/ClasUpdTimeTable"));
export const LugInqRpl = loadable(() => import("./lounge/LugInqRpl"));
export const LugInqWrite = loadable(() => import("./lounge/LugInqWrite"));
export const LugChat = loadable(() => import("./lounge/LugChat"));
export const TestZone = loadable(() => import("./testzone/TestZone"));
export const WrongAnswerNotes = loadable(() => import("./testzone/WrongAnswerNotes"));
export const PlayerMain = loadable(() => import("./player/PlayerMain"));
export const StarShop = loadable(() => import("./starshop/StarShop"));

export const InitTimeTable = loadable(() => import("./init/InitTimeTable"));
export const NotFound = loadable(() => import("./common/NotFound"));
export const OnlineLibraryBanner = loadable((props) => import("./online/onlineLibraryBanner"));

export const SpecialClassMain = loadable(() => import("./specialClass/SpecialClassMain"));
export const SpecialClassSub = loadable(() => import("./specialClass/SpecialClassSub"));
export const SchoolCourseMain = loadable(() => import("./schoolCourse/SchoolCourseMain"));
export const SchoolCourseDetail = loadable(() => import("./schoolCourse/SchoolCourseDetail"));
export const SubjectStudyGuideDetail = loadable(() => import("./schoolCourse/SubjectStudyGuideDetail"));

export const LicenseClassMain = loadable(() => import("./licenseClass/LicenseClassMain"));
export const LicenseClassSub = loadable(() => import("./licenseClass/LicenseClassSub"));

export const LiveQnaMain = loadable(() => import("./liveqna/LiveQnaMain"));
export const AiRecommendQuestion = loadable(() => import("./aiSuggest/qst/AiRecommendQuestion"));

export const ReferenceRoom = loadable(() => import("./referenceRoom/ReferenceRoom"));
export const AllZip = loadable(() => import("./allZip/AllZip"));

export const PdfViewer = loadable(() => import("./pdfViewer/PdfViewer"));
export const ServiceMenu = loadable(() => import("./serviceMenu/ServiceMenu"));

export const EnglishVocaMain = loadable(() => import("./englishVoca/index"));
export const EnglishVocaTextbook = loadable(() => import("./englishVoca/Textbook"));
export const EnglishVocaSchedule = loadable(() => import("./englishVoca/Schedule"));
export const HighSchoolVoca = loadable(() => import("./englishVoca/HighSchoolVoca"));
export const BasicVoca = loadable(() => import("./englishVoca/BasicVoca"));

export const Curriculum = loadable(() => import("./curriculum/Curriculum"));
export const EvaluationReport = loadable(() => import("./evaluation/EvaluationReport"));
export const ScienceEvaluationReport = loadable(() => import("./scienceEvaluation/ScienceEvaluationReport"));
export const EnglishLibrary = loadable(() => import("./englishLibrary/EnglishLibrary"));

export const FindId = loadable(() => import("./find/FindId"));
export const FindPassword = loadable(() => import("./find/FindPassword"));
export const JoinGuide = loadable(() => import("./guide/JoinGuide"));
export const ScheduleGuide = loadable(() => import("./guide/ScheduleGuide"));
export const EventPop = loadable(() => import("./eventPop/EventPop"));

export const PdfTest = loadable(() => import("./pdfTest/PdfTest"));
export const StudyMusic = loadable(() => import("./studyMusic/StudyMusic"));

export const AiMe = loadable(() => import("./aiMe/AiMe"));
export const AiPlayer = loadable(() => import("./aiMe/AiPlayer"));

export const Studytest = loadable(() => import("./Studytest/Studytest"));

export const PerformExamMain = loadable(() => import("./performExam/PerformExamMain"));
export const PerformExamDetail = loadable(() => import("./performExam/PerformExamDetail"));

export const EnrollSchoolCurriculumInfo = loadable(() => import("./enrollSchoolCurriculumInfo"));

export const LiteratureLibrary = loadable(() => import("./literatureLibrary/LiteratureLibrary"));
export const PlayerTest = loadable(() => import("./playerTest/playerTest"));
export const PdfViewerTest = loadable(() => import("./pdfViewerTest/PdfViewerTest"));

// 문학 독후감 대회
export const LiteratureBookReport = loadable(() => import("./literatureBookReport/LiteratureBookReport"));
export const BookReportWrite = loadable(() => import("./literatureBookReport/BookReportWrite"));
export const BookReportAnnouncement = loadable(() => import("./literatureBookReport/BookReportAnnouncement"));
export const MyBookReport = loadable(() => import("./literatureBookReport/MyBookReport"));
export const MyBookReportDetail = loadable(() => import("./literatureBookReport/MyBookReportDetail"));
export const AwardWinningWorkDetail = loadable(() => import("./literatureBookReport/AwardWinningWorkDetail"));
export const ExamReportCard = loadable(() => import("./examReport/ExamReportCard"));

// TEST라운지 영수모의고사 성적우수자
export const ExcellentExamAnnouncement = loadable(() => import("./testzone/ExcellentExamAnnouncement"));

/* 성적우수장학생 페이지 */
export const Reward = loadable(() => import("./reward"));

/* 성적우수장학생 신청 페이지*/
export const ApplyReward = loadable(() => import("./reward/Apply"));

export const AlltabLearningMate = loadable(() => import("./alltabLearningMate/AlltabLearningMate"));

// 초등 -> 중등 이관동의
export const MidServiceTermInfo = loadable(() => import("./transfer/MidServiceTermInfo"));
export const MidTransferList = loadable(() => import("./transfer/MidTransferList"));
export const MidServiceResult = loadable(() => import("./transfer/MidServiceResult"));
export const AiMeEng = loadable(() => import("./aiMe/AiMeEng"));

// 와이즈멘토 진로진단검사
export const WiseMentorTest = loadable(() => import("./wiseMentor/wiseMentorTest"));
